// src/components/FormPage.jsx
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './FormPage.css'; // Import the CSS file

function FormPage({ setFormData }) {
  const [data, setData] = useState({
    nome: '',
    idade: '',
    whatsapp: '',
    email: '',
    tipoPessoa: '',
    orgaoNome: '',
  });
  const [showOrgaoField, setShowOrgaoField] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });

    // Show the orgaoNome field and make it required based on tipoPessoa selection
    if (name === 'tipoPessoa') {
      const isOrgOrPessoaJuridica = value === 'orgao publico' || value === 'pessoa juridica';
      setShowOrgaoField(isOrgOrPessoaJuridica);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Ensure that orgaoNome is not empty if tipoPessoa requires it
    if (showOrgaoField && !data.orgaoNome) {
      alert('Please fill out the Nome do Orgão/Empresa field.');
      return;
    }

    setFormData(data);
    navigate('/select-image');
  };

  return (
    <div className="form-container">
      <form className="styled-form" onSubmit={handleSubmit}>
        <h2>Fala um pouco sobre você</h2>
        <input
          name="nome"
          placeholder="Nome"
          value={data.nome}
          onChange={handleInputChange}
          required
        />
        <select
          name="idade"
          value={data.idade}
          onChange={handleInputChange}
          required
        >
          <option value="">Selecione a Idade</option>
          <option value="menor-de-18">menor de 18</option>
          <option value="18-25">18-25</option>
          <option value="26-35">26-35</option>
          <option value="36-45">36-45</option>
        </select>
        <input
          name="whatsapp"
          placeholder="WhatsApp"
          value={data.whatsapp}
          onChange={handleInputChange}
          required
        />
        <input
          name="email"
          placeholder="Email"
          type="email"
          value={data.email}
          onChange={handleInputChange}
          required
        />
        <select
          name="tipoPessoa"
          value={data.tipoPessoa}
          onChange={handleInputChange}
          required
        >
          <option value="">Selecione</option>
          <option value="orgao publico">Orgão Público</option>
          <option value="pessoa juridica">Pessoa Jurídica</option>
          <option value="pessoa fisica">Pessoa Física</option>
        </select>
        
        {showOrgaoField && (
          <input
            name="orgaoNome"
            placeholder="Nome do Orgão/Empresa"
            value={data.orgaoNome}
            onChange={handleInputChange}
            required={showOrgaoField} // Conditionally required
          />
        )}

        <button type="submit">Enviar</button>
      </form>
    </div>
  );
}

export default FormPage;
